/**
 * Application Configuration
 * 
 * This module contains configuration settings for the parent application,
 * including iframe integration settings for the embedded chat interface.
 */

export interface AppConfig {
  /** URL of the chat interface to embed in the iframe */
  chatIframeUrl: string;
  /** Width of the iframe (CSS value) */
  chatIframeWidth: string;
  /** Height of the iframe (CSS value) */
  chatIframeHeight: string;
  /** Development server port for the parent application */
  devPort: number;
}

/**
 * Default configuration for the application
 * 
 * To use a different chat interface URL (e.g., production), update the
 * chatIframeUrl value or set it via environment variables.
 */
export const config: AppConfig = {
  // Default to localhost for development
  // In production, this should point to your deployed chat interface
  chatIframeUrl: import.meta.env.VITE_CHAT_URL || 'http://localhost:5173',
  
  // Iframe dimensions - can be adjusted based on your layout needs
  chatIframeWidth: '100%',
  chatIframeHeight: '600px',
  
  // Parent app runs on port 5174 to avoid conflicts with chat interface (5173)
  devPort: 5174
};

/**
 * Get the chat iframe URL
 * This function allows for runtime configuration if needed
 */
export function getChatIframeUrl(): string {
  return config.chatIframeUrl;
}

/**
 * Get iframe dimensions
 */
export function getIframeDimensions(): { width: string; height: string } {
  return {
    width: config.chatIframeWidth,
    height: config.chatIframeHeight
  };
}
